/* eslint-disable */
// @ts-nocheck

/**
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as GoogleProtobufTimestamp from '../../../google/protobuf/timestamp.pb';
import * as EdukitaPaulaBackendV3TeacherFeedbackV3Service from './teacher_feedback_v3_service.pb';
import * as fm from '@generated/fetch.pb';

export enum WorksheetScoreStatus {
    WORKSHEET_SCORE_STATUS_UNSPECIFIED = 'WORKSHEET_SCORE_STATUS_UNSPECIFIED',
    WORKSHEET_SCORE_STATUS_NOT_STARTED = 'WORKSHEET_SCORE_STATUS_NOT_STARTED',
    WORKSHEET_SCORE_STATUS_IN_PROGRESS = 'WORKSHEET_SCORE_STATUS_IN_PROGRESS',
    WORKSHEET_SCORE_STATUS_COMPLETED = 'WORKSHEET_SCORE_STATUS_COMPLETED',
    WORKSHEET_SCORE_STATUS_SKIPPED = 'WORKSHEET_SCORE_STATUS_SKIPPED',
}

export type GetMathFeedbackOptionsRequest = Record<string, never>;

export type GetMathFeedbackOptionsResponse = {
    comfortLevels?: EdukitaPaulaBackendV3TeacherFeedbackV3Service.V3ComfortLevel[];
    positiveStandoutOptions?: MathFeedbackOption[];
    thingsToImproveOptions?: MathFeedbackOption[];
};

export type MathFeedbackOption = {
    key?: string;
    value?: string;
    category?: string;
};

export type GetMathFeedbackDetailsRequest = {
    sessionId?: string;
};

export type GetMathFeedbackDetailsResponse = {
    session?: MathFeedbackSession;
    students?: MathStudentFeedback[];
};

export type MathFeedbackSession = {
    id?: string;
    garageSessionId?: string;
    garageCourseName?: string;
    garageSessionStartTime?: GoogleProtobufTimestamp.Timestamp;
    garageSessionEndTime?: GoogleProtobufTimestamp.Timestamp;
    garageTeacherId?: string;
    garageTeacherName?: string;
    garageLevelId?: string;
    garageLevelLabel?: string;
    isComplete?: boolean;
    sessionType?: string;
    unitSessionNumber?: number;
    students?: MathStudentFeedback[];
};

export type MathStudentFeedback = {
    id?: string;
    feedbackId?: string;
    garageStudentId?: string;
    garageStudentName?: string;
    garageStudentNickname?: string;
    btsAttendance?: boolean;
    isOnTime?: boolean;
    comfortLevelId?: number;
    observationNote?: string;
    positiveStandouts?: string[];
    thingsToImprove?: string[];
    flagToParents?: string;
    urgentEscalation?: string;
    worksheetStatus?: WorksheetStatus;
    worksheetFilled?: boolean;
};

export type WorksheetStatus = {
    isFilled?: boolean;
    totalWorksheets?: number;
    scoredWorksheets?: number;
};

export type MathAttendanceInfo = {
    attendance?: boolean;
    onTime?: boolean;
};

export type MathStudentFeedbackInput = {
    studentId?: string;
    attendanceInfo?: MathAttendanceInfo;
    studentName?: string;
    studentNickname?: string;
};

export type PostMathFeedbackDetailsRequest = {
    sessionId?: string;
    requester?: string;
    courseId?: string;
    roomId?: string;
    teacherId?: string;
    teacherName?: string;
    courseName?: string;
    sessionStartTime?: GoogleProtobufTimestamp.Timestamp;
    sessionEndTime?: GoogleProtobufTimestamp.Timestamp;
    levelId?: string;
    levelLabel?: string;
    feedbacks?: MathStudentFeedbackInput[];
    sessionType?: string;
    unitSessionNumber?: number;
};

export type PostMathFeedbackDetailsResponse = {
    success?: boolean;
    message?: string;
    feedbackId?: string;
};

export type MathStudentFeedbackUpdate = {
    garageStudentId?: string;
    btsAttendance?: boolean;
    isOnTime?: boolean;
    comfortLevelId?: number;
    observationNote?: string;
    positiveStandouts?: string[];
    thingsToImprove?: string[];
    flagToParents?: string;
    urgentEscalation?: string;
};

export type PutMathFeedbackDetailsRequest = {
    sessionId?: string;
    requester?: string;
    isComplete?: boolean;
    students?: MathStudentFeedbackUpdate[];
};

export type PutMathFeedbackDetailsResponse = {
    success?: boolean;
    message?: string;
};

export type GetMathFeedbackByFilterRequest = {
    teacherId?: string;
    startDate?: GoogleProtobufTimestamp.Timestamp;
    endDate?: GoogleProtobufTimestamp.Timestamp;
    studentId?: string;
    page?: number;
    pageSize?: number;
    teacherName?: string;
    withDetails?: boolean;
};

export type GetMathFeedbackByFilterResponse = {
    sessions?: MathFeedbackSession[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
};

export type GetWorksheetScoresRequest = {
    studentId?: string;
    bookId?: string;
    page?: number;
    pageSize?: number;
    progress?: string;
};

export type GetWorksheetScoresResponse = {
    scores?: WorksheetScore[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
};

export type WorksheetScore = {
    id?: string;
    worksheetId?: string;
    bookId?: string;
    unitId?: string;
    subunitId?: string;
    writtenScore?: number;
    totalScore?: number;
    isSkipped?: boolean;
    progress?: string;
};

export type PostWorksheetScoreRequest = {
    studentId?: string;
    sessionId?: string;
    worksheetId?: string;
    bookId?: string;
    unitId?: string;
    subunitId?: string;
    writtenScore?: number;
    totalScore?: number;
    isSkipped?: boolean;
    progress?: string;
    updatedBy?: string;
};

export type PostWorksheetScoreResponse = {
    success?: boolean;
    message?: string;
};

export type GetWorksheetAssignmentRequest = {
    studentId?: string;
    sessionId?: string;
    bookId?: number;
    unitId?: number;
    subunitId?: number;
    page?: number;
    pageSize?: number;
};

export type MathWorksheetStudent = {
    id?: string;
    name?: string;
    levelLabel?: string;
};

export type GetWorksheetAssignmentResponse = {
    assignments?: WorksheetAssignmentRow[];
    totalCount?: number;
    books?: MathBookCatalog[];
    studentId?: string;
    sessionId?: string;
    student?: MathWorksheetStudent;
    sessionStartTime?: GoogleProtobufTimestamp.Timestamp;
};

export type MathBookCatalog = {
    id?: number;
    name?: string;
    units?: MathUnitCatalog[];
};

export type MathUnitCatalog = {
    id?: number;
    name?: string;
    subunits?: MathSubunitCatalog[];
    number?: number;
};

export type MathSubunitCatalog = {
    id?: number;
    name?: string;
    worksheets?: MathWorksheetCatalog[];
    number?: number;
    isCheckpoint?: boolean;
};

export type MathWorksheetCatalog = {
    id?: number;
    name?: string;
    startPage?: number;
    endPage?: number;
    totalScore?: number;
};

export type WorksheetAssignmentRow = {
    worksheetId?: number;
    bookId?: number;
    bookName?: string;
    unitNumber?: number;
    unitName?: string;
    subunitName?: string;
    isCheckpoint?: boolean;
    worksheetName?: string;
    pageStart?: number;
    pageEnd?: number;
    isSkipped?: boolean;
    writtenScore?: number;
    totalScore?: number;
    progress?: WorksheetScoreStatus;
    isSupplement?: boolean;
    subunitNumber?: number;
    garageSessionId?: string;
};

export type BookOption = {
    id?: number;
    name?: string;
    gaudiaLevelId?: number;
};

export type PostWorksheetAssignmentRequest = {
    studentId?: string;
    sessionId?: string;
    requester?: string;
    assignments?: WorksheetAssignmentUpdate[];
    sessionStartTime?: GoogleProtobufTimestamp.Timestamp;
};

export type WorksheetAssignmentUpdate = {
    worksheetId?: number;
    isSkipped?: boolean;
    writtenScore?: number;
    totalScore?: number;
    isSupplement?: boolean;
};

export type PostWorksheetAssignmentResponse = {
    success?: boolean;
    message?: string;
};

export type GetBooksRequest = {
    levelId?: string;
};

export type GetBooksResponse = {
    books?: Book[];
};

export type Book = {
    id?: string;
    name?: string;
};

export type GetUnitsRequest = {
    bookId?: string;
};

export type GetUnitsResponse = {
    units?: Unit[];
};

export type Unit = {
    id?: string;
    name?: string;
};

export type GetSubunitsRequest = {
    unitId?: string;
};

export type GetSubunitsResponse = {
    subunits?: Subunit[];
};

export type Subunit = {
    id?: string;
    name?: string;
    order?: number;
};

export type GetStudentTrackerSessionHistoryRequest = {
    studentId?: string;
    startDate?: GoogleProtobufTimestamp.Timestamp;
    endDate?: GoogleProtobufTimestamp.Timestamp;
};

export type GetStudentTrackerSessionHistoryResponse = {
    entries?: SessionHistoryEntry[];
};

export type SessionHistoryEntry = {
    sessionDate?: GoogleProtobufTimestamp.Timestamp;
    sessionName?: string;
    levelName?: string;
    attended?: boolean;
};

export type GetStudentTrackerAttendanceHistoryRequest = {
    studentId?: string;
    month?: number;
    year?: number;
};

export type GetStudentTrackerAttendanceHistoryResponse = {
    totalSessions?: number;
    attendedSessions?: number;
    attendanceRate?: number;
};

export class TeacherFeedbackMathService {
    static GetMathFeedbackDetails(
        this: void,
        req: GetMathFeedbackDetailsRequest,
        initReq?: fm.InitReq
    ): Promise<GetMathFeedbackDetailsResponse> {
        return fm.fetchRequest<GetMathFeedbackDetailsResponse>(
            `/v3/math-feedback/sessions/${
                req.sessionId
            }/details?${fm.renderURLSearchParams(req, ['sessionId'])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static PostMathFeedbackDetails(
        this: void,
        req: PostMathFeedbackDetailsRequest,
        initReq?: fm.InitReq
    ): Promise<PostMathFeedbackDetailsResponse> {
        return fm.fetchRequest<PostMathFeedbackDetailsResponse>(
            `/v3/math-feedback/sessions/${req.sessionId}/details`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static PutMathFeedbackDetails(
        this: void,
        req: PutMathFeedbackDetailsRequest,
        initReq?: fm.InitReq
    ): Promise<PutMathFeedbackDetailsResponse> {
        return fm.fetchRequest<PutMathFeedbackDetailsResponse>(
            `/v3/math-feedback/sessions/${req.sessionId}/details`,
            { ...initReq, method: 'PUT', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static GetMathFeedbackByFilter(
        this: void,
        req: GetMathFeedbackByFilterRequest,
        initReq?: fm.InitReq
    ): Promise<GetMathFeedbackByFilterResponse> {
        return fm.fetchRequest<GetMathFeedbackByFilterResponse>(
            `/v3/math-feedback?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetMathFeedbackOptions(
        this: void,
        req: GetMathFeedbackOptionsRequest,
        initReq?: fm.InitReq
    ): Promise<GetMathFeedbackOptionsResponse> {
        return fm.fetchRequest<GetMathFeedbackOptionsResponse>(
            `/v3/math-feedback/options?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetWorksheetScores(
        this: void,
        req: GetWorksheetScoresRequest,
        initReq?: fm.InitReq
    ): Promise<GetWorksheetScoresResponse> {
        return fm.fetchRequest<GetWorksheetScoresResponse>(
            `/v3/math-worksheets/scores?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static PostWorksheetScore(
        this: void,
        req: PostWorksheetScoreRequest,
        initReq?: fm.InitReq
    ): Promise<PostWorksheetScoreResponse> {
        return fm.fetchRequest<PostWorksheetScoreResponse>(
            `/v3/math-worksheets/scores`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static GetWorksheetAssignment(
        this: void,
        req: GetWorksheetAssignmentRequest,
        initReq?: fm.InitReq
    ): Promise<GetWorksheetAssignmentResponse> {
        return fm.fetchRequest<GetWorksheetAssignmentResponse>(
            `/v3/math/students/${req.studentId}/sessions/${
                req.sessionId
            }/worksheet-assignment?${fm.renderURLSearchParams(req, [
                'studentId',
                'sessionId',
            ])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static PostWorksheetAssignment(
        this: void,
        req: PostWorksheetAssignmentRequest,
        initReq?: fm.InitReq
    ): Promise<PostWorksheetAssignmentResponse> {
        return fm.fetchRequest<PostWorksheetAssignmentResponse>(
            `/v3/math/students/${req.studentId}/sessions/${req.sessionId}/worksheet-assignment`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static GetBooks(
        this: void,
        req: GetBooksRequest,
        initReq?: fm.InitReq
    ): Promise<GetBooksResponse> {
        return fm.fetchRequest<GetBooksResponse>(
            `/v3/math-books?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetUnits(
        this: void,
        req: GetUnitsRequest,
        initReq?: fm.InitReq
    ): Promise<GetUnitsResponse> {
        return fm.fetchRequest<GetUnitsResponse>(
            `/v3/math-units?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetSubunits(
        this: void,
        req: GetSubunitsRequest,
        initReq?: fm.InitReq
    ): Promise<GetSubunitsResponse> {
        return fm.fetchRequest<GetSubunitsResponse>(
            `/v3/math-subunits?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetStudentTrackerSessionHistory(
        this: void,
        req: GetStudentTrackerSessionHistoryRequest,
        initReq?: fm.InitReq
    ): Promise<GetStudentTrackerSessionHistoryResponse> {
        return fm.fetchRequest<GetStudentTrackerSessionHistoryResponse>(
            `/v3/math-tracker/session-history?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetStudentTrackerAttendanceHistory(
        this: void,
        req: GetStudentTrackerAttendanceHistoryRequest,
        initReq?: fm.InitReq
    ): Promise<GetStudentTrackerAttendanceHistoryResponse> {
        return fm.fetchRequest<GetStudentTrackerAttendanceHistoryResponse>(
            `/v3/math-tracker/attendance-history?${fm.renderURLSearchParams(
                req,
                []
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
}
